import React from 'react';
import { useDispatch } from 'react-redux';

import { ticketUpdate } from '~/actions/ticket';
import { patchTicketStage } from '~/api/tickets';
import rocketSrc from '~/assets/images/cta/rocket.svg';
import { showToast } from '~/components/Shared/EcToast/showToast';
import { useAsync } from '~/hooks/useAsync';
import { useIntl } from 'react-intl';
import { api } from '~/redux/api/createApi';
import * as TAGS from '~/redux/api/endpoints/allEndpoints';
import { useRouting } from '~/routing/useRouting';
import { SUCCESS } from '~/types/toast.types';
import CtaSection from '~/ui/components/CtaSection/CtaSection';

const SendTicketActionCta = ({ ticketId, title, nextStageString }) => {
  const intl = useIntl();
  const { navigate } = useRouting();
  const dispatch = useDispatch();

  const { executor: handleNextStageClick, isLoading: isLoadingNextStage } =
    useAsync(
      patchTicketStage,
      { ticketId },
      {
        successHandler: async (res) => {
          dispatch(
            api.util.invalidateTags([
              TAGS.TAG_BY_TICKET_SUMMARY,
              TAGS.TAG_CURRENT_VERSION,
            ]),
          );
          dispatch(
            ticketUpdate({
              stages: res.stages,
            }),
          );
          showToast(
            SUCCESS,
            intl.formatMessage({
              id: 'SendTicketActionCta.stageCompletedSuccess',
              defaultMessage: 'Successfully completed stage',
              description: 'Success message when stage is completed',
            }),
          );
          navigate(`/workflow/tickets/${ticketId}`);
        },
        errorToast: intl.formatMessage({
          id: 'SendTicketActionCta.transitionError',
          defaultMessage:
            'Transition to the next stage failed. Please try again.',
          description: 'Error message when stage transition fails',
        }),
      },
    );

  return (
    <CtaSection
      actionButton={{
        text: intl.formatMessage({
          id: 'SendTicketActionCta.sendButton',
          defaultMessage: 'Send',
          description: 'Send button text',
        }),
        onClick: handleNextStageClick,
        isLoading: isLoadingNextStage,
      }}
      description={intl.formatMessage(
        {
          id: 'SendTicketActionCta.sendDescription',
          defaultMessage: 'Send your ticket for {nextStageString}',
          description:
            'Description for sending ticket to next stage, Example nextStageString = "Review"',
        },
        { nextStageString },
      )}
      imageSrc={rocketSrc}
      title={title}
    />
  );
};

export default SendTicketActionCta;
